"use client"

import styled from "@emotion/styled"
import Container from "@eurodrive/ui/Container"
import { getUmbracoMediaUrl } from "@eurodrive/utils/getUmbracoMediaUrl"
import { Button, Typography } from "@mui/material"
import Image from "next/image"
import { useState } from "react"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 0;
  gap: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 20px;
    padding: 64px 0;
  }
`

const ImageContainer = styled.div`
  position: relative;
  height: 190px;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 510px;
  }
  width: 100%;
`
const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 17px;
  align-items: center;
  text-align: center;
`
const ColorList = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 30px;
    justify-content: center;
  }

  align-items: center;
  height: 56px;
  padding: 0 20px;
`

const ColorItem = styled(Button)<{ selected: boolean; circleColor: string }>`
  display: flex;
  gap: 16px;
  width: ${(props) => (props.selected ? "56px" : "40px")};
  height: ${(props) => (props.selected ? "56px" : "40px")};
  border-radius: 100%;
  margin: 0;
  min-width: 0;
  background-color: ${(props) => props.circleColor};
  transition:
    width 0.3s ease,
    height 0.3s ease;
  &:hover {
    background-color: ${(props) => props.color};
  }
`

export default function ColorPicker({
  colors,
}: {
  colors: { colorPicker: string; carImage: string; title: string }[]
}) {
  const [selectedColor, setSelectedColor] = useState(colors[0])
  if (colors.length === 0) return null
  return (
    <Container>
      <StyledLayout>
        <ImageContainer>
          <Image
            src={getUmbracoMediaUrl(selectedColor.carImage)}
            alt=""
            fill
            style={{ objectFit: "cover" }}
          />
        </ImageContainer>
        <ContentBox>
          <Typography variant="body1">{selectedColor.title}</Typography>
          <ColorList>
            {colors.map((item, i) => (
              <ColorItem
                circleColor={item.colorPicker}
                key={i}
                onClick={() => setSelectedColor(item)}
                selected={selectedColor.colorPicker === item.colorPicker}
              />
            ))}
          </ColorList>
        </ContentBox>
      </StyledLayout>
    </Container>
  )
}
